<template>
  <v-layout justify-center>
    <v-flex xs12 md10>
      <v-layout row wrap text-xs-center>
        <v-flex xm12 order-md1 order-xs2>
          <v-autocomplete
            :items="searchSelect"
            v-model="searchType"
            menu-props="auto"
            label="Title"
            hide-details
            solo
            @change="searchTitles"
          ></v-autocomplete>
        </v-flex>
        <v-flex xm12 order-md3 order-xs3 class="display-1 text-sm-right">
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click="buildEmail()" slot="activator" :disabled="!selected">
              <v-icon dark>email</v-icon>
            </v-btn>
            <span>Email Selected</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click="buildText()" slot="activator" :disabled="!selected">
              <v-icon dark>message</v-icon>
            </v-btn>
            <span>Text Selected</span>
          </v-tooltip>
          <v-menu offset-y>
            <v-btn v-if="isAdmin" slot="activator" icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile v-on:click="onExport" :disabled="!selected">
                <v-list-tile-action>
                <v-icon :disabled="!selected">cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Member List</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportComm">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Members Committees</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportCert">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Member Certificates</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportSched">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Schedule Report</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportNoSched">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>No Schedule Report</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>

      <vue-good-table
        ref="my-table"
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :columns="columns"
        :isLoading=this.isTableLoading
        :rows="rows"
        @on-cell-click="onCellClick"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true
        }"
        :search-options="{
          enabled: true,
          skipDiacritics: true
        }"
        :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPageDropdown: [10, 20, 50]
      }">
        <template slot="loadingContent">
          <div>
            <v-progress-circular
              :size="50"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </template>
        <div slot="table-actions">
          <v-switch label="Include All" v-model="searchAll"></v-switch>
        </div>
        <div slot="table-actions-bottom">
          <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'fullName'">
            <v-layout align-center justify-start row fill-height>
              <v-flex sm3 lg2>
                <v-avatar
                  slot="activator"
                  size="52px"
                  color="indigo"
                >
                  <img v-if="props.row.image" :src="props.row.picture" :lazy-src="props.row.picture" alt="Avatar" />
                  <span v-else class="white--text headline">{{ props.row.firstName.substr(0, 1) }}{{ props.row.lastName.substr(0, 1) }}</span>
                </v-avatar>
              </v-flex>
              <v-flex sm9 lg10>
                <div style="font-weight: bold;">{{ props.row.fullName }} <span v-if="props.row.birthDate > minorDate" class="red--text">(Minor)</span><br/>({{ props.row.Title.name }})</div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'email'">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12 style="text-align: center;">
                <a :href="'mailto:' + props.row.email" style="text-decoration: none;">
                  <v-tooltip bottom>
                    <v-icon slot="activator">email</v-icon>
                    <span>{{ props.row.email }}</span>
                  </v-tooltip>
                </a>
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <v-avatar
              color="blue lighten-4"
              class="mr-2 mt-2"
              size="30"
              style="cursor: pointer;"
              @click="editItem(props)"
            >
              <v-icon small>edit</v-icon>
            </v-avatar>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </v-flex>

    <v-btn
      v-if="isAdmin"
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click.stop="newItem"
    >
      <v-icon>person_add</v-icon>
    </v-btn>

    <v-dialog v-model="viewDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md6 order-xs2 order-md1>
                <v-flex xs12 class="text-xs-center text-sm-center">
                  <span class="headline">{{ editedItem.name }}</span><br />
                  <span class="subheading">({{ editedItem.title }})</span>
                </v-flex>
                <v-flex xs12 v-if="editedItem.birthDate > minorDate">
                </v-flex>
                <v-flex xs12 v-else>
                  <v-btn
                    v-if="editedItem.email"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="sendEmail"
                  >
                    Email {{editedItem.firstName}}
                    <v-icon right dark>email</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.cellPhone"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callMobile"
                  >
                    Call Mobile
                    <v-icon right dark>mobile_screen_share</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.homePhone"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callHome"
                  >
                    Call Home
                    <v-icon right dark>phone</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.workPhone"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callWork"
                  >
                    Call Work
                    <v-icon right dark>business</v-icon>
                  </v-btn>
                </v-flex>
                  <span class="headline">{{ currentYear }} Committees</span><br />
                  <v-list>
                    <v-list-tile
                      v-for="item in currentCommittees"
                      :key="item.id"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title v-text="item.name"></v-list-tile-title>
                        <v-list-tile-sub-title>{{ item.title }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>

                  <span class="headline">{{ currentYear }} Schedules</span><br />
                  <v-list>
                    <v-list-tile
                      v-for="item in mySched1"
                      :key="item.id"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.committeeName }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ item.formatDate }}:</v-list-tile-sub-title>
                        <v-list-tile-sub-title>{{ item.start }} - {{ item.end }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>

                </v-flex>
              <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="editedItem.picture" height="150" v-if="editedItem.image"/>
                <v-icon v-else x-large color="blue">person</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <UserForm
      :visible="showUserForm"
      :item="editedItem"
      :isEdit="isEdit"
      :isOpen="isOpen"
      @close="closeThis"
      @saveUser="handleSaveUser"
    />

    <EmailForm
      :visible="showEmailForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <TextForm
      :visible="showTextForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import UserForm from './forms/UserForm'
import EmailForm from './forms/EmailForm'
import TextForm from './forms/TextForm'
import moment from 'moment'
import XLSX from 'xlsx'

export default {
  components: {
    VueGoodTable,
    UserForm,
    EmailForm,
    TextForm
  },
  data () {
    return {
      currentPage: 'Members',
      currentYear: 0,
      isAdmin: false,
      searchSelect: [
        { text: 'All Active', value: '' },
        { text: 'All Active (No Volunteers)', value: 'Director-Member-Past President-Past Director-Assoc. Member-Hon. Member-Staff' },
        { text: 'Directors', value: 'Director' },
        { text: 'Members', value: 'Member' },
        { text: 'Directors/Members', value: 'Director-Member' },
        { text: 'Volunteers', value: 'Volunteer' },
        { text: 'Directors/Members/Volunteers', value: 'Director-Member-Volunteer' },
        { text: 'Others', value: 'Other' },
        { text: 'Partners', value: 'Partner' }
      ],
      searchType: '',
      showUserForm: false,
      showEmailForm: false,
      showTextForm: false,
      isEdit: false,
      isOpen: true,
      viewDialog: false,
      isTableLoading: false,
      isMounted: false,
      searchAll: false,
      minorDate: '',
      sendEmail: '',
      callMobile: '',
      callHome: '',
      callWork: '',
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name',
          field: 'fullName',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Email',
          field: 'email',
          thClass: 'hidden-sm-and-down email-width text-center',
          tdClass: 'hidden-sm-and-down email-width',
          html: true
        },
        {
          label: 'Mobile',
          field: 'cellPhone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Status',
          field: 'Title.name',
          thClass: 'hidden-lg-and-down hidden-sm-and-up text-center',
          tdClass: 'hidden-lg-and-down hidden-sm-and-up',
          type: 'text'
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: true,
          html: true,
          width: '60px'
        }
      ],
      rows: [],
      printMembers: {},
      editedItem: {
        index: 0,
        id: 0,
        name: '',
        title: '',
        firstName: '',
        image: '',
        picture: '',
        imageFile: '',
        email: '',
        cellPhone: '',
        homePhone: '',
        workPhone: '',
        count: 0
      },
      defaultItem: {
        index: 0,
        id: 0,
        name: '',
        title: '',
        firstName: '',
        image: '',
        picture: '',
        imageFile: '',
        email: '',
        cellPhone: '',
        homePhone: '',
        workPhone: '',
        count: 0
      },
      emails: [],
      mobileTypes: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      currentCommittees: [],
      myInfo: {},
      mySched: [],
      mySched1: [],
      committeeList: []
    }
  },

  created () {
    this.isTableLoading = true
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear

    if (this.$store.state.isAdmin) {
      this.isAdmin = true
    } else {
      this.isAdmin = this.$store.state.controls.includes('Users')
    }

    if (this.isAdmin) {
      this.columns[this.columns.length - 1].hidden = false
    }

    let minorDate = moment()
    minorDate = minorDate.subtract(21, 'years')
    this.minorDate = moment(minorDate).format('YYYY-MM-DD')

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getItems()
    this.getMobiles()
    // this.isTableLoading = false
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    searchAll () {
      this.isTableLoading = true
      this.getItems()
    }
  },

  methods: {
    async searchTitles () {
      if (this.searchType) {
        try {
          const response = await Api().get('users_by_title/' + this.searchType)
          this.rows = response.data
          this.isTableLoading = false
        } catch (error) {
          this.error = error.response.data.error
        }
      } else {
        let allUsers = 'users'

        if (this.searchAll) {
          allUsers = 'all_users'
        }

        try {
          const response = await Api().get(allUsers)
          this.rows = response.data
          this.isTableLoading = false
        } catch (error) {
          this.error = error.response.data.error
        }
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    async onCellClick (params) {
      try {
        if (params.column.field === 'fullName') {
          this.editedItem.name = params.row.fullName
          this.editedItem.title = params.row.Title.name
          this.editedItem.firstName = params.row.firstName
          this.editedItem.address = params.row.address1
          this.editedItem.city = params.row.city
          this.editedItem.state = params.row.state
          this.editedItem.zip = params.row.zip
          this.editedItem.email = params.row.email
          this.editedItem.cellPhone = params.row.cellPhone
          this.editedItem.homePhone = params.row.homePhone
          this.editedItem.workPhone = params.row.workPhone
          this.sendEmail = 'mailto:' + params.row.email
          this.callMobile = 'tel:' + params.row.cellPhone
          this.callHome = 'tel:' + params.row.homePhone
          this.callWork = 'tel:' + params.row.workPhone
          this.editedItem.image = params.row.image
          this.editedItem.picture = params.row.picture
          this.editedItem.birthDate = params.row.birthDate

          const response = await Api().get('users_committees/' + params.row.id)
          const userDetail = response.data

          const userCommittees = userDetail.map(a => ({
            id: a.id,
            name: a.name,
            title: a.title,
            year: a.year
          }))
          console.log('comm', userCommittees)

          this.currentCommittees = userCommittees.filter(obj => {
            return obj.year === this.currentYear
          })

          const response2 = await Api().get('/get_committeelist/' + this.currentYear)
          this.committeeList = response2.data

          const response1 = await Api().get('/my_schedule/' + params.row.id)
          this.myInfo = response1.data[0]

          this.mySched = this.myInfo.Schedules

          this.mySched.sort(function (a, b) {
            let nameA = a.startTime.toLowerCase()
            let nameB = b.startTime.toLowerCase()

            if (nameA < nameB) {
              return -1
            }

            if (nameA > nameB) {
              return 1
            }

            return 0
          })

          this.mySched.sort(function (a, b) {
            let nameA = a.date.toLowerCase()
            let nameB = b.date.toLowerCase()

            if (nameA < nameB) {
              return -1
            }

            if (nameA > nameB) {
              return 1
            }

            return 0
          })

          this.mySched1 = []

          for (let i in this.mySched) {
            let item = {}
            item = this.committeeList.find(item => item.id === this.mySched[i].CommitteeId)
            console.log('list', this.committeeList)
            console.log('committee', this.mySched[i].CommitteeId, item)

            if (item) {
              this.mySched[i].committeeName = item.name

              const [year, month, day] = this.mySched[i].date.split('-')
              this.mySched[i].formatDate = `${month}/${day}/${year}`

              this.mySched[i].start = moment(this.mySched[i].startTime, 'HH:mm').format('h:mm a')
              this.mySched[i].end = moment(this.mySched[i].endTime, 'HH:mm').format('h:mm a')
              this.mySched[i].userId = ''

              this.mySched1.push(this.mySched[i])
            }
            console.log(this.mySched1)
          }

          this.viewDialog = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
      // params.row - row object
      // params.column - column object
      // params.rowIndex - index of this row on the current page.
      // params.event - click event
    },

    newItem () {
      this.isEdit = false
      this.showUserForm = true
    },

    buildEmail () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].email
      }
      this.ccList = this.emailList
      this.bccList = this.emailList

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].email
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    async getMobiles () {
      try {
        const response = await Api().get('mobiles')
        console.log('Mobiles', response.data)
        this.mobileTypes = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    buildText () {
      for (let i in this.$refs['my-table'].selectedRows) {
        // console.log(this.$refs['my-table'].selectedRows[i])

        if (this.$refs['my-table'].selectedRows[i].MobileTypeId >= 1) {
          let mobileType = this.mobileTypes.filter(obj => {
            return obj.id === this.$refs['my-table'].selectedRows[i].MobileTypeId
          })

          // console.log('type', mobileType[0].extension)

          let phone = this.$refs['my-table'].selectedRows[i].cellPhone.replace(/[^+\d]+/g, '')
          this.emails[i] = phone + mobileType[0].extension
        }
      }

      this.showTextForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    closeThis (item) {
      console.log('test')
      this.emails = []
      this.showUserForm = false
      this.showEmailForm = false
      this.showTextForm = false
    },

    handleSaveUser (item) {
      console.log('item', item)
      if (item.id > 0) {
        let objIndex = this.rows.findIndex(obj => obj.id === item.id)

        Object.assign(this.rows[objIndex], item)
      } else {
        this.rows.push(item)
      }

      // console.log(item)
    },

    editItem (props) {
      console.log('props', props)
      this.editedItem = props.row
      this.editedItem.index = props.index
      this.editedItem.password = ''
      // this.editedItem.diet = props.formattedRow.diet
      // this.editedItem.count = props.formattedRow.count
      // this.editedItem.image = props.row.image
      // this.editedItem.picture = props.row.picture
      this.isEdit = true
      this.showUserForm = true
      // this.dialog = true
    },

    save () {
      if (this.editedIndex > -1) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.rows.push(this.editedItem)
        this.addItem(this.editedItem)
      }

      this.close()
    },

    deleteItem () {
      let r = confirm('Are you sure you want to delete ' + this.editedItem.name + '?')

      if (r === true) {
        this.rows.splice(this.editedIndex, 1)
        this.removeItem(this.editedItem.id)
      }

      this.close()
    },

    deleteItemList (props) {
      let r = confirm('Are you sure you want to delete ' + props.formattedRow.name + '?')

      if (r === true) {
        this.rows.splice(props.index, 1)
        this.removeItem(props.row.id)
      }
    },

    async getItems () {
      let allUsers = 'users'

      if (this.searchAll) {
        allUsers = 'all_users'
      }

      try {
        const response = await Api().get(allUsers)
        this.rows = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async addItem (item) {
      let formData = new FormData()
      formData.append('name', item.name)
      formData.append('diet', item.diet)
      formData.append('image', item.image)
      formData.append('count', item.count)
      formData.append('imageFile', item.imageFile)

      try {
        const response = await Api().post('animals', formData)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem (item) {
      let formData = new FormData()
      formData.append('name', item.name)
      formData.append('diet', item.diet)
      formData.append('image', item.image)
      formData.append('count', item.count)
      formData.append('imageFile', item.imageFile)

      try {
        const response = await Api().put('animals/' + item.id, formData)
        this.editedItem.image = response.data.body.image
        Object.assign(this.rows[this.editedIndex], this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async removeItem (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      // this.dialog = false
      this.viewDialog = false

      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem)
      //   this.editedIndex = -1
      // }, 300)
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'First Name': a.firstName,
        'Last Name': a.lastName,
        'Title': a.Title.name,
        'Address': a.address1,
        'City': a.city,
        'State': a.state,
        'Zip': a.zip,
        'Email': a.email,
        'Mobile': a.cellPhone,
        'Home Phone': a.homePhone,
        'Work Phone': a.workPhone,
        'Mail Notice': a.mailNotice,
        'Badge': a.badge,
        'Skills': a.skills,
        'Start Date': a.startDate
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Member List'

      XLSX.utils.book_append_sheet(wb, membersWS, 'Members')

      XLSX.writeFile(wb, 'members.xlsx')
    },

    async onExportCert () {
      try {
        const response = await Api().get('certificates')

        const certificates = response.data
        console.log('rows', certificates)
        let printArray = []
        let printItem = {}

        for (let i in certificates) {
          let date = moment(certificates[i].date).format('MM/DD/YYYY')

          printItem['Certificate'] = certificates[i].name
          printItem['Date'] = date
          printItem['Notes'] = certificates[i].notes
          printItem['Name'] = certificates[i].User.fullName
          printItem['Mobile'] = certificates[i].User.cellPhone
          printItem['Home Phone'] = certificates[i].User.homePhone
          printItem['Work Phone'] = certificates[i].User.workPhone

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Member Certificates'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Member Certificates')

        XLSX.writeFile(wb, 'members_certificates.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportSched () {
      try {
        const response = await Api().get('schedule_report')

        const schedule = response.data
        console.log('rows', schedule)
        let printArray = []
        let printItem = {}

        for (let i in schedule) {
          let stime = '2026-01-01 ' + schedule[i].startTime + ':00'
          let etime = '2026-01-01 ' + schedule[i].endTime + ':00'
          let date = moment(schedule[i].date).format('MM/DD/YYYY')
          let time = moment(stime).format('h:mm a')
          let endTime = moment(etime).format('h:mm a')

          printItem['Committee'] = schedule[i].commName
          printItem['Year'] = schedule[i].year
          printItem['Schedule'] = schedule[i].schedname
          printItem['Date'] = date
          printItem['Start Time'] = time
          printItem['End Time'] = endTime
          printItem['Notes'] = schedule[i].notes
          printItem['Name'] = schedule[i].lastName + ', ' + schedule[i].firstName
          printItem['Title'] = schedule[i].name
          printItem['Email'] = schedule[i].email
          printItem['Address'] = schedule[i].address1
          printItem['City'] = schedule[i].city
          printItem['State'] = schedule[i].state
          printItem['Zip'] = schedule[i].zip
          printItem['Mobile'] = schedule[i].cellPhone

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Schedule Report'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Schedule Report')

        XLSX.writeFile(wb, 'schedule_report.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportNoSched () {
      try {
        const response = await Api().get('no_sched/2025')

        const schedule = response.data
        console.log('rows', schedule)
        let printArray = []
        let printItem = {}

        for (let i in schedule) {
          printItem['Name'] = schedule[i].lastName + ', ' + schedule[i].firstName
          printItem['Title'] = schedule[i].name
          printItem['Email'] = schedule[i].email
          printItem['Address'] = schedule[i].address1
          printItem['City'] = schedule[i].city
          printItem['State'] = schedule[i].state
          printItem['Zip'] = schedule[i].zip
          printItem['Mobile'] = schedule[i].cellPhone

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Schedule Report'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Schedule Report')

        XLSX.writeFile(wb, 'schedule_report.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportComm () {
      try {
        const response = await Api().get('allusers_committees/' + this.currentYear)

        // console.log('rows', this.rows)
        const committees = response.data
        let printArray = []
        let printItem = {}

        for (let i in this.rows) {
          printItem['Name'] = this.rows[i].fullName
          printItem['Title'] = this.rows[i].Title.name
          printItem['Email'] = this.rows[i].email
          printItem['Mobile'] = this.rows[i].cellPhone
          printItem['Home Phone'] = this.rows[i].homePhone
          printItem['Work Phone'] = this.rows[i].workPhone

          const results = committees.filter(obj => {
            return obj.id === this.rows[i].id
          })

          if (results.length > 0) {
            let k = 1
            for (let j in results) {
              printItem['Comm' + k] = results[j].name + ' (' + results[j].title + ')'
              k++
            }
          }
          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Member List'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Members Committeess')

        XLSX.writeFile(wb, 'members_committees.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
  width: calc(100% + 17px) !important;
}

.email-width {
  max-width: 100px;
}
.text-center {
  text-align: center;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Users.vue